import styled from "styled-components";

const Slide = styled.div``;

export default Slide;
